import script from "./colorcardDistribute.vue?vue&type=script&setup=true&lang=js"
export * from "./colorcardDistribute.vue?vue&type=script&setup=true&lang=js"

import "./colorcardDistribute.vue?vue&type=style&index=0&id=a6fc823c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86183\\Desktop\\yw-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a6fc823c"]])

export default __exports__